<div>
  <div class="section-head hidden-xs nav-help-dropdown-heading">Help</div>
  @for (menuItem of helpMenuItems$ | async; track menuItem) {
    <app-help-menu-item [menuItem]="menuItem"></app-help-menu-item>
  }
  <a [href]="contactTechnicalSupportUrl" class="dropdown-item" target="_blank" id="techSupport">
    <i aria-hidden="true" class="pbi-icon-mini pbi-monitor"></i> {{ contactTechnicalSupportText }}
  </a>

  @if (contactSalesAnchorText === 'Contact Sales') {
    <a class="dropdown-item" id="contactSales" routerLink="{{ contactSalesAnchorUrl }}">
      <i aria-hidden="true" class="pbi-icon-mini pbi-telephone"></i> {{ contactSalesAnchorText }}</a
    >
  }
  @if (contactSalesAnchorText === 'Contact Mastercard Data Sources') {
    <a class="dropdown-item" id="contactMastercard" href="{{ contactSalesAnchorUrl }}">
      <i aria-hidden="true" class="pbi-icon-mini pbi-mail-outline"></i> {{ contactSalesAnchorText }}</a
    >
  }
</div>
